import { postAppGraphql } from "./appGraphqlService";

type MeRoleResponse = {
  me?: {
    role?: string | null;
  } | null;
};

export async function fetchActualUserRole(
  token: string,
): Promise<string | null> {
  const payload = await postAppGraphql<MeRoleResponse>({
    token,
    operationName: "Me",
    query: "query Me { me { role } }",
    throwOnErrors: false,
  });

  return payload.data?.me?.role ?? null;
}
